var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KButton',{attrs:{"primary":"","disabled":"","text":"Basic link","appearance":"basic-link"}})
}
var staticRenderFns = []

export { render, staticRenderFns }